import { render, staticRenderFns } from "./mmp.vue?vue&type=template&id=d971cc2e&scoped=true&"
import script from "./mmp.vue?vue&type=script&lang=js&"
export * from "./mmp.vue?vue&type=script&lang=js&"
import style0 from "./mmp.vue?vue&type=style&index=0&id=d971cc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d971cc2e",
  null
  
)

export default component.exports